

module.exports = {
    NoLicense: 1,
    Trial: 2,
    Freemium: 3,
    Maintenance: 4,
    CouldNotStart: 5,
};



// WEBPACK FOOTER //
// ./src/state/licenseType.js